import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
/**
 * Project : HSS-Online
 * @class Lecture hall management Api Service
 * @author Waruna Gamage
 */
export class LhmsApiService {

  facultyId;

  constructor(private apiService: ApiService) {
    this.facultyId = environment.faculty_id;
  }

   /**
   * @method Get All Facilities
   */
    getFacilities(): Observable<any> {
      return this.apiService.get('/facility');
    }

  /**
   * @method Get Facility by id
   */
   getFacilityById(id:number): Observable<any> {
    return this.apiService.get('/facility/'+id);
  }

  /**
   * @method Get by Facility by id
   */
  getHallByFacility(id:number): Observable<any> {
    return this.apiService.get('/lechall_facility/byfacility/'+id);
  }

  /**
   * @method Get by lecture hall id
   */
  getFacility(id:number): Observable<any> {
    return this.apiService.get('/lechall_facility/bylecturehall/'+id);
  }

  /**
   * @method Get All Lecture halls
   */
  getLectureHalls(): Observable<any> {
    return this.apiService.get('/lecture_hall');
  }

  /**
   * @method Get All Lecture halls by category
   */
  getLectureHallsbyCat(catId: string): Observable<any> {
    return this.apiService.get('/lecture_hall/bycategory/'+catId);
  }

  /**
   * @method Get Categories
   */
  getLecHallCategories(): Observable<any> {
    return this.apiService.get('/lechall_category');
  }

  /**
   * @method Get Lecture hall by id
   */
  getLectureHallById(id:number): Observable<any> {
    return this.apiService.get('/lecture_hall/'+id);
  }

  /**
   * @method Get All Lecture hall facilities
   */
  getHallFacilities(): Observable<any> {
    return this.apiService.get('/lechall_facility');
  }


  /**
   * @method Get Lecture hall facility by id
   */
  getLectureHallFacilityById(id:number): Observable<any> {
    return this.apiService.get('/lechall_facility/'+id);
  }


  /**
   * @method Hall bookings
   */
  getHallBookings(): Observable<any> {
    return this.apiService.get('/hall_booking');
  }

  /**
   * @method Hall bookings by hall
   */
  getBookingsByHall(id:number): Observable<any> {
    return this.apiService.get('/hall_booking/hall/'+id);
  }

  getOccurrenceTypes(): Observable<any> {
    return this.apiService.get('/repeat_type');
  }

  /**
   * @method Create Facility year
   */
  addBooking(data: any) {
    return this.apiService.post('/hall_booking/' ,null, data);
  }

  getBookingById(id:number): Observable<any> {
    return this.apiService.get('/hall_booking/hall/dates/'+id);
  }

  getBookingSummery(fromDate: string, toDate: string): Observable<any> {
    return this.apiService.get('/hall_booking/hall/summery/'+fromDate+'/'+toDate);
  }

  updateBooking(id: string, data: any) {
    return this.apiService.upload('/hall_booking/' + id, data);
  }

  deleteBooking(id: string) {
    return this.apiService.delete('/hall_booking/' + id, null);
  }
}
